import React from "react";

import LeaseForm from "./LeaseForm";

export default function LeaseDetail(props: {
  bagObject: IBagObject;
}): React.JSX.Element {
  /**
   * A detailed view of a lease.
   */
  return (
    <div>
      <LeaseForm bagObject={props.bagObject} />
    </div>
  );
}
